<template>
  <div class="container mt-4">
    <!-- Loading and Error States -->
    <div v-if="store.loading" class="text-center">
      <div class="spinner-border" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
      <p>Loading data...</p>
    </div>
    <div v-else-if="store.error" class="alert alert-danger">
      {{ store.error }}
    </div>
    <div v-else>
      <!-- Navigation Tabs -->
      <ul class="nav nav-tabs" id="myTab" role="tablist">
        <li class="nav-item" role="presentation">
          <button
            class="nav-link"
            :class="{ active: activeTab === 'prokuror' }"
            id="prokuror-tab"
            data-bs-toggle="tab"
            data-bs-target="#prokuror"
            type="button"
            role="tab"
            aria-controls="prokuror"
            aria-selected="true"
            @click="activeTab = 'prokuror'"
          >{{ $t('mundesipunesimi.perprokuror') }}</button>
        </li>
        <li class="nav-item" role="presentation">
          <button
            class="nav-link"
            :class="{ active: activeTab === 'staf' }"
            id="staf-tab"
            data-bs-toggle="tab"
            data-bs-target="#staf"
            type="button"
            role="tab"
            aria-controls="staf"
            aria-selected="false"
            @click="activeTab = 'staf'"
          >{{ $t('mundesipunesimi.perstaf') }}</button>
        </li>
        <li class="nav-item" role="presentation">
          <button
            class="nav-link"
            :class="{ active: activeTab === 'aplikacioni' }"
            id="aplikacioni-tab"
            data-bs-toggle="tab"
            data-bs-target="#aplikacioni"
            type="button"
            role="tab"
            aria-controls="aplikacioni"
            aria-selected="false"
            @click="activeTab = 'aplikacioni'"
          >{{ $t('mundesipunesimi.aplikacioni') }}</button>
        </li>
        <li class="nav-item" role="presentation">
          <button
            class="nav-link"
            :class="{ active: activeTab === 'arkiva' }"
            id="arkiva-tab"
            data-bs-toggle="tab"
            data-bs-target="#arkiva"
            type="button"
            role="tab"
            aria-controls="arkiva"
            aria-selected="false"
            @click="activeTab = 'arkiva'"
          >{{ $t('mundesipunesimi.arkiva') }}</button>
        </li>
      </ul>

      <!-- Tab Content -->
      <div class="tab-content mt-3" id="myTabContent">
        <div
          class="tab-pane fade"
          :class="{ 'show active': activeTab === 'prokuror' }"
          id="prokuror"
          role="tabpanel"
          aria-labelledby="prokuror-tab"
        >
          <KonkursetTable :table-data="dataProkuror" />
        </div>
        <div
          class="tab-pane fade"
          :class="{ 'show active': activeTab === 'staf' }"
          id="staf"
          role="tabpanel"
          aria-labelledby="staf-tab"
        >
          <KonkursetTable :table-data="dataStaf" />
        </div>
        <div
          class="tab-pane fade"
          :class="{ 'show active': activeTab === 'aplikacioni' }"
          id="aplikacioni"
          role="tabpanel"
          aria-labelledby="aplikacioni-tab"
        >
          <KonkursetTable :table-data="dataAplikacioni" />
        </div>
        <div
          class="tab-pane fade"
          :class="{ 'show active': activeTab === 'arkiva' }"
          id="arkiva"
          role="tabpanel"
          aria-labelledby="arkiva-tab"
        >
          <KonkursetTable :table-data="dataArkiva" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import KonkursetTable from '../share/KonkursetTable.vue';
import { usePostsStore } from '@/store/PostStore/postStore';

export default {
  components: { KonkursetTable },
  setup() {
    const store = usePostsStore();
    return { store };
  },
  data() {
    return {
      activeTab: 'staf', // Default tab
      dataProkuror: [],
      dataStaf: [],
      dataAplikacioni: [],
      dataArkiva: [],
      webPage: '',
      language: 'AL',
      count: 0,
      categoryId: 1142,
      currentPage: 1,
      itemsPerPage: 10,
    };
  },
  async mounted() {
    await this.fetchPosts();
  },
  methods: {
    // === FUNKSIONI KRYESOR: Merr dhe kategorizon postet ===
   async fetchPosts() {
  try {
    const postsData = {
          webPage: this.webPage,
          language: this.language,
          count: this.count,
          categoryId: this.categoryId,
          currentPage: this.currentPage,
          itemsPerPage: this.itemsPerPage,
        };
    await this.store.getMundesiPunesimiPosts(postsData);
    const posts = this.store.mundesiPunesimiPosts;

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const formatDate = (dateString) => {
      if (!dateString) return 'N/A';
      const date = new Date(dateString);
      if (isNaN(date)) return 'Data e pavlefshme';
      return `${String(date.getDate()).padStart(2,'0')}.${String(date.getMonth()+1).padStart(2,'0')}.${date.getFullYear()}`;
    };

    const isInArchive = (post) => {
      if (!post.deadlineDate || !post.createdDate) return false;
      const created = new Date(post.createdDate);
      const deadline = new Date(post.deadlineDate);
      if (isNaN(created) || isNaN(deadline)) return false;

      const createdOnly = new Date(created.getFullYear(), created.getMonth(), created.getDate());
      const deadlineOnly = new Date(deadline.getFullYear(), deadline.getMonth(), deadline.getDate());
      const todayOnly = new Date(today.getFullYear(), today.getMonth(), today.getDate());

      if (createdOnly.getTime() === deadlineOnly.getTime()) return false;
      if ((post.competitionTypeId === 1143 || post.competitionTypeId === 1144) && deadlineOnly < todayOnly) {
        return true;
      }
      return false;
    };

    const mapPost = (post) => ({
      data: formatDate(post.createdDate),
      titulli: post.priceDetailsTitle || 'Pa titull',
      afati: formatDate(post.deadlineDate),
      lloji: post.pDetailsContent || '-',
      dokumenti: post.pDetailsFileUrl || '#',
    });

    this.dataProkuror = posts.filter(p => p.competitionTypeId === 1143 && !isInArchive(p)).map(mapPost);
    this.dataStaf = posts.filter(p => p.competitionTypeId === 1144 && !isInArchive(p)).map(mapPost);
    this.dataAplikacioni = posts.filter(p => p.competitionTypeId === 1145).map(mapPost);
    this.dataArkiva = posts.filter(p => (p.competitionTypeId === 1143 || p.competitionTypeId === 1144) && isInArchive(p)).map(mapPost);

    console.log("Arkiva:", this.dataArkiva.map(p => `${p.titulli} → ${p.afati}`));

  } catch (error) {
    console.error("Gabim:", error);
    this.store.error = "Gabim gjatë ngarkimit.";
  }
}
  },
};
</script>

<style scoped>
.nav-item .nav-link {
  color: var(--color-system-secondary);
  font-weight: 500;
  white-space: nowrap;
}

.nav-item .nav-link.active {
  background-color: var(--color-system-primary) !important;
  color: white !important;
}

.nav-tabs {
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
  -webkit-overflow-scrolling: touch;
  border-bottom: 2px solid #ddd;
}

.nav-tabs::-webkit-scrollbar {
  height: 6px;
}

.nav-tabs::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
}

.tab-content {
  overflow-x: auto;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.08);
  padding: 1rem;
}

.table-responsive {
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

table {
  width: 100%;
  border-collapse: collapse;
  min-width: 600px;
}

th, td {
  white-space: nowrap;
  text-align: left;
  padding: 0.75rem;
  vertical-align: middle;
  border-bottom: 1px solid #dee2e6;
}

@media (max-width: 768px) {
  th, td {
    font-size: 0.9rem;
    padding: 0.5rem;
  }
  .tab-content { padding: 0.5rem; }
}

@media (max-width: 576px) {
  table { min-width: 480px; }
  .nav-tabs { font-size: 0.85rem; }
}
</style>